import { transactionService } from "@/common/api.service";
import {
    GET_TRANSACTION_LIST,
    GET_TRANSACTION_REMITTER_RECEIVER_DETAILS,
    GET_TRANSACTION_PAYMENT_DETAILS,
    GET_TRANSACTION_PAYOUT_DETAILS,
    GET_TRANSACTION_PROVIDER_RESPONSE,
    GET_PAYOUT_ATTEMPTS,
    GET_PROVIDER_LIST,
    GET_TRANSACTION_COMMENTS,
    POST_TRANSACTION_COMMENT,
    UPDATE_TRANSACTION_COMMENT,
    GET_TRANSACTION_PAYMENTS_LOGS,
    PROCESS_TRANSACTIONS,
    GET_TRANSACTION_STATUS,
    UPDATE_TRANSACTION_STATUS,
    MANUAL_SUCCESS_TRANSACTION,
    MANUAL_FAIL_TRANSACTION,
    UPDATE_PAYOUT_STATUS,
    TRANSACTION_PAYMENT_CAPTURE,
    CHECK_TRANSACTION_STATUS,
    TRANSACTION_MOMO_NETWORKS,
    UPDATE_TRANSACTION_MOMO_NUMBER,
    TRANSACTION_BANK_LIST,
    UPDATE_TRANSACTION_BANK_ACCOUNT,
    GET_NAME_FROM_NAMECHECK,
    UPDATE_RECEIVER_NAME
 } from "./actions.type";
import { SET_ERROR,ISLOADING } from "./mutations.type";
const state = {
  errors: null,
  transaction_list: {},
};

const getters = {
  transaction_list(state) {
    return state.transaction_list;
  },
};

const actions = {
  async [GET_TRANSACTION_LIST](context, payload) {
    transactionService.init();
    transactionService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      transactionService
        .get(`transaction/list${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // get transaction receivers & remitter Details
  async [GET_TRANSACTION_REMITTER_RECEIVER_DETAILS](context, payload) {
    transactionService.init();
    transactionService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      transactionService
        .get(`transaction/remitter-receiver-details/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // get transaction payment Details
  async [GET_TRANSACTION_PAYMENT_DETAILS](context, payload) {
    transactionService.init();
    transactionService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      transactionService
        .get(`transaction/transaction-payment-details/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // get transaction payout Details
  async [GET_TRANSACTION_PAYOUT_DETAILS](context, payload) {
    transactionService.init();
    transactionService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      transactionService
        .get(`transaction/transaction-payout-details/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // get transaction payment Details
  async [GET_TRANSACTION_PROVIDER_RESPONSE](context, payload) {
    transactionService.init();
    transactionService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      transactionService
        .get(`transaction/provider-response-details/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // get payout attempts by reference id
  async [GET_PAYOUT_ATTEMPTS](context, payload) {
    transactionService.init();
    transactionService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      transactionService
        .get(`transaction/payout-attempts/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // get transaction Comments
  async [GET_TRANSACTION_COMMENTS](context, payload) {
    transactionService.init();
    transactionService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      transactionService
        .get(`transaction/cosmostransaction-comments-log/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // post transaction comment
  async [POST_TRANSACTION_COMMENT](context, payload) {
    transactionService.init();
    transactionService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      transactionService
        .post(`transaction/post-comment`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // update transaction comment
  async [UPDATE_TRANSACTION_COMMENT](context, payload) {
    transactionService.init();
    transactionService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      transactionService
        .put(
          `transaction/update-comment/${payload.commentId}/${payload.transactionId}`,
          { comment: payload.comment },
        )
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // get transaction Payments(checkout) logs
  async [GET_TRANSACTION_PAYMENTS_LOGS](context, payload) {
    transactionService.init();
    transactionService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      transactionService
        .get(`transaction/cosmospayment-log/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Process the transactions
  async [PROCESS_TRANSACTIONS](context, payload) {
    transactionService.init();
    transactionService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      transactionService
        .post(`transaction/process`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  async [GET_PROVIDER_LIST](context, payload) {
    transactionService.init();
    transactionService.setHeader();
    return new Promise((resolve) => {
      transactionService
        .get(`momo/payout-provider-list${payload}`)
        .then((data) => {
          resolve(data);
        })
        .catch(({ response }) => {
          resolve(response);
        });
    });
  },

  // Get all Transaction status
  async [GET_TRANSACTION_STATUS]() {
    transactionService.init();
    transactionService.setHeader();
    return new Promise((resolve) => {
      transactionService
        .get(`transaction/status-list`)
        .then((data) => {
          resolve(data);
        })
        .catch(({ response }) => {
          resolve(response);
        });
    });
  },

  // Manual Success Transaction
  async [MANUAL_SUCCESS_TRANSACTION](context, payload) {
    transactionService.init();
    transactionService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      transactionService
        .post(`transaction/manual-success`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Manual Fail Transaction
  async [MANUAL_FAIL_TRANSACTION](context, payload) {
    transactionService.init();
    transactionService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      transactionService
        .post(`transaction/fail-transaction-manually`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Update Transaction Status
  async [UPDATE_TRANSACTION_STATUS](context, payload) {
    transactionService.init();
    transactionService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      transactionService
        .post(`transaction/update-transaction-status`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Update Payout Status
  async [UPDATE_PAYOUT_STATUS](context, payload) {
    transactionService.init();
    transactionService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      transactionService
        .post(`transaction/update-payout-status`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Transaction payment capture
  async [TRANSACTION_PAYMENT_CAPTURE](context, payload) {
    transactionService.init();
    transactionService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      transactionService
        .post(`transaction/auto-capture`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Transaction payment capture
  async [CHECK_TRANSACTION_STATUS](context, payload) {
    transactionService.init();
    transactionService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      transactionService
        .get(`transaction/check-status/${payload.transaction_id}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Transaction momo networks listing
  async [TRANSACTION_MOMO_NETWORKS](context, payload) {
    transactionService.init();
    transactionService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      transactionService
        .get(`momo/provider-list${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // Update Transaction momo munber
  async [UPDATE_TRANSACTION_MOMO_NUMBER](context, payload) {
    transactionService.init();
    transactionService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      transactionService
        .post(`momo/update-number-network`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
      });
    },

    // Country wise bank listing
    async [TRANSACTION_BANK_LIST](context, payload) {
      transactionService.init();
      transactionService.setHeader();
      context.commit(ISLOADING, true);
      return new Promise(resolve => {
        transactionService.get(`bank/list${payload}`)
        .then(( data ) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
      })
    },
    // Update account number and bank for transaction
    async [UPDATE_TRANSACTION_BANK_ACCOUNT](context, payload) {
      transactionService.init();
      transactionService.setHeader();
      context.commit(ISLOADING, true);
      return new Promise(resolve => {
        transactionService.post(`bank/update-account`,payload)
        .then(( data ) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
      })
    },

    async [GET_NAME_FROM_NAMECHECK](context, payload) {
      transactionService.init();
      transactionService.setHeader();
      context.commit(ISLOADING, true);
      return new Promise((resolve) => {
        transactionService
          .get(`transaction/namecheck/${payload}`)
          .then((data) => {
            context.commit(ISLOADING, false);
            resolve(data);
          })
          .catch(({ response }) => {
            context.commit(ISLOADING, false);
            resolve(response);
          });
      });
    },

    async [UPDATE_RECEIVER_NAME](context, payload) {
      transactionService.init();
      transactionService.setHeader();
      context.commit(ISLOADING, true);
      return new Promise((resolve) => {
        transactionService
          .put(
            `transaction/update-receiver-name/${payload.transactionId}`,
            payload,
          )
          .then((data) => {
            context.commit(ISLOADING, false);
            resolve(data);
          })
          .catch(({ response }) => {
            context.commit(ISLOADING, false);
            resolve(response);
          });
      });
    },
};
const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [ISLOADING](state, loading) {
    state.isLoading = loading;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
